<template>
  <div class="col-sm-12">
    <div class="card-body">
      <div class="table-responsive">
        <table class="table table-striped table-bordered tabla-usuarios">
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Email</th>
              <th>Rol</th>
              <th>Estado</th>
              <th>Creado</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in get_rows" :key="row.id">
              <td>{{ row.name }}</td>
              <td>{{ row.email }}</td>
              <td>
                <span class="badge badge-rol">{{ nombreRol(row.rol) }}</span>
              </td>
              <td>
                <span class="badge badge-estado" :class="row.status === 'active' ? 'bg-success' : 'bg-danger'">
                  {{ row.status === "active" ? "activo" : "inactivo" }}
                </span>
              </td>
              <td class="text-nowrap">{{ formatoFecha(row.created_at) }}</td>
              <td>
                <div class="acciones">
                  <button type="button" class="btn btn-accion btn-copiar" title="Copiar ID" @click="copiarId(row)">
                    <vue-feather type="copy" size="14" />
                  </button>
                  <button type="button" class="btn btn-accion btn-correo"
                    title="Enviar correo de restablecimiento de contraseña" :disabled="enviandoCorreo === row.id"
                    @click="enviarRestablecimiento(row)">
                    <span v-if="enviandoCorreo === row.id" class="spinner-border spinner-border-sm" role="status"
                      aria-hidden="true"></span>
                    <vue-feather v-else type="mail" size="14" />
                  </button>
                  <button type="button" class="btn btn-accion btn-editar" title="Editar usuario"
                    @click="actualizarUsuario(row)">
                    <vue-feather type="edit" size="14" />
                  </button>
                  <button v-if="puedeEliminar(row)" type="button" class="btn btn-accion btn-eliminar"
                    title="Eliminar usuario" :disabled="eliminando === row.id" @click="eliminarUsuario(row)">
                    <span v-if="eliminando === row.id" class="spinner-border spinner-border-sm" role="status"
                      aria-hidden="true"></span>
                    <vue-feather v-else type="trash-2" size="14" />
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <PaginacionTabla :pagina="currentPage" :total-paginas="num_pages()" @cambiar="change_page" />
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import PaginacionTabla from "@/components/PaginacionTabla.vue";

export default {
  name: "TablaUsuarios",
  components: { PaginacionTabla },
  props: ["dataTabla"],
  emits: ["mostrarModal"],
  data() {
    return {
      elementsPerPage: 20,
      currentPage: 1,
      allData: [],
      enviandoCorreo: null,
      eliminando: null,
    };
  },
  watch: {
    dataTabla: {
      handler(val) {
        this.allData = val || [];
        if (this.currentPage > this.num_pages()) this.currentPage = this.num_pages();
      },
      immediate: true,
    },
  },
  computed: {
    get_rows() {
      const start = (this.currentPage - 1) * this.elementsPerPage;
      return this.allData.slice(start, start + this.elementsPerPage);
    },
  },
  methods: {
    nombreRol(id) {
      const roles = this.$store.state.autenticacion?.roles || [];
      return roles.find((r) => String(r.id) === String(id))?.name || id;
    },
    formatoFecha(valor) {
      if (!valor) return "—";
      const d = new Date(valor);
      if (Number.isNaN(d.getTime())) return "—";
      const dos = (n) => String(n).padStart(2, "0");
      return `${dos(d.getDate())}/${dos(d.getMonth() + 1)}/${d.getFullYear()} ${dos(d.getHours())}:${dos(d.getMinutes())}`;
    },
    num_pages() {
      return Math.ceil(this.allData.length / this.elementsPerPage) || 1;
    },
    change_page(page) {
      this.currentPage = page;
    },
    actualizarUsuario(row) {
      this.$emit("mostrarModal", row);
    },
    puedeEliminar(row) {
      const actual = this.$store.state.autenticacion.usuarioActual;
      return Boolean(actual?.esAdmin) && String(actual.id) !== String(row.id);
    },
    async eliminarUsuario(row) {
      const escapar = (texto) =>
        String(texto ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
      const { isConfirmed } = await Swal.fire({
        icon: "warning",
        title: "Eliminar usuario",
        html: `
          <p class="mb-2"><strong>${escapar(row.name)}</strong><br><small>${escapar(row.email)}</small></p>
          <p class="small mb-0">El usuario quedará inactivo, se cerrará su sesión en todos sus dispositivos y ya no
          aparecerá en esta tabla. Podrás consultarlo en Usuarios eliminados.</p>
        `,
        showCancelButton: true,
        confirmButtonText: "Eliminar",
        cancelButtonText: "Cancelar",
        confirmButtonColor: "#e11d48",
        focusCancel: true,
      });
      if (!isConfirmed) return;

      this.eliminando = row.id;
      try {
        await this.$store.dispatch("autenticacion/eliminarUsuario", { id: row.id });
        await this.$store.dispatch("autenticacion/consultarUsuarios");
        Swal.fire({ icon: "success", title: "Usuario eliminado", timer: 1800, showConfirmButton: false });
      } catch (e) {
        Swal.fire({ icon: "error", title: "Error", text: e.msg || "No se pudo eliminar el usuario." });
      } finally {
        this.eliminando = null;
      }
    },
    async copiarId(row) {
      try {
        await navigator.clipboard.writeText(String(row.id));
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "success",
          title: "ID copiado",
          showConfirmButton: false,
          timer: 1500,
        });
      } catch (e) {
        Swal.fire({ icon: "info", title: "ID del usuario", text: String(row.id) });
      }
    },
    async enviarRestablecimiento(row) {
      const { isConfirmed } = await Swal.fire({
        icon: "question",
        title: "Enviar correo de restablecimiento",
        text: `Se enviará a ${row.email} un enlace para restablecer su contraseña (válido por 1 hora).`,
        showCancelButton: true,
        confirmButtonText: "Enviar",
        cancelButtonText: "Cancelar",
      });
      if (!isConfirmed) return;

      this.enviandoCorreo = row.id;
      try {
        const data = await this.$store.dispatch("autenticacion/enviarRestablecimiento", { id: row.id });
        Swal.fire({ icon: "success", title: "Correo enviado", text: data?.msg || `Se envió el correo a ${row.email}.` });
      } catch (e) {
        Swal.fire({ icon: "error", title: "Error", text: e.msg || "No se pudo enviar el correo." });
      } finally {
        this.enviandoCorreo = null;
      }
    },
  },
};
</script>

<style scoped>
.tabla-usuarios th {
  font-weight: 700;
  vertical-align: bottom;
}

.tabla-usuarios td {
  vertical-align: top;
}

.badge-rol {
  background-color: #5c61f2;
  padding: 5px 8px;
  font-size: 12px;
}

.badge-estado {
  padding: 5px 8px;
  font-size: 12px;
}

.acciones {
  display: flex;
  gap: 8px;
}

.btn-accion {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: none;
  border-radius: 4px;
  color: #fff;
  transition: transform 0.15s ease, opacity 0.15s ease;
}

.btn-accion:hover:not(:disabled) {
  color: #fff;
  opacity: 0.9;
  transform: translateY(-1px);
}

.btn-accion:disabled {
  color: #fff;
  opacity: 0.65;
}

.btn-copiar {
  background-color: #48a3d7;
}

.btn-correo {
  background-color: #f5b72f;
}

.btn-editar {
  background-color: #5c61f2;
}

.btn-eliminar {
  background-color: #e11d48;
}
</style>
